import React from 'react';
import { Image, StyleSheet, View } from 'react-native';
import Svg, { Defs, RadialGradient, Rect, Stop } from 'react-native-svg';

import PanelGrain from '../../../assets/profileRedesign/panel-grain.png';
import { useSvgId } from '../../../utils/hooks/useSvgId';

type Props = {
	/** The panel's corner radius, in screen pixels. */
	radius: number;
	/** The modal's scale (mobile design units to screen pixels). */
	scale: number;
};

/**
 * The desktop modal panel's own fill - the "red vignette grain" style the desktop artboards
 * ("Edit Profile / Desktop — Screen States" 5605:102663, "Statistics / Desktop" 5605:101689) give
 * every modal: a dark red that lifts toward the middle, a fine grain over it and a red glow inside
 * the rim (`inset 0 0 12.5px red` on the 1.25x desktop frame, so 10 in mobile units).
 *
 * The mobile modals carry no fill and let a copy of the app backdrop read through instead; on
 * desktop the panel floats over the blurred live screen, so it paints this rather than that.
 */
const DesktopPanelFill = ({ radius, scale }: Props) => {
	const gradientId = useSvgId('desktopPanelVignette');

	return (
		<View
			pointerEvents='none'
			style={[StyleSheet.absoluteFill, { borderRadius: radius, overflow: 'hidden' }]}
		>
			<Svg width='100%' height='100%' style={StyleSheet.absoluteFill}>
				<Defs>
					<RadialGradient id={gradientId} cx='50%' cy='50%' rx='75%' ry='55%'>
						<Stop offset='0' stopColor='#7A0303' />
						<Stop offset='0.55' stopColor='#6C0101' />
						<Stop offset='1' stopColor='#470202' />
					</RadialGradient>
				</Defs>
				<Rect x='0' y='0' width='100%' height='100%' fill={`url(#${gradientId})`} />
			</Svg>
			<Image source={PanelGrain} resizeMode='repeat' style={StyleSheet.absoluteFill} />
			<View
				style={[
					StyleSheet.absoluteFill,
					// react-native-web passes `boxShadow` through to CSS; the inset glow has no RN prop.
					{ borderRadius: radius, boxShadow: `inset 0 0 ${10 * scale}px #FF0000` } as any,
				]}
			/>
		</View>
	);
};

export default DesktopPanelFill;
